// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27gray%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M1.5 5l6 6 6-6H1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Stylish&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* navbar.css */

/* General styles for the navbar */
.navbar {
  background: rgba(
    255,
    255,
    255,
    0.2
  ); /* Transparent white for glassy effect */
  backdrop-filter: blur(10px); /* Apply blur for a frosted-glass look */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 2rem;
  border-radius: 10px; /* Soft rounded corners */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  color: #ffffff; /* White text for contrast */
  top:0;
  left: 0;
  height: 100px; /* Fixed height for the navbar */ 
  
}

/* Navbar menu container for images */
.navbar-left {
  display: flex;
  align-items: center;
  margin-left: 3rem;
  margin-right: 1 rem;
  
  gap: 1rem; /* Spacing between items */
  flex: 1 1; /* Take up 50% of the navbar width */
}

/* General styles for the images to appear in a hole */
.navbar-left img {
  height: 60px; /* Adjust size as needed */
  width: 150px; /* Keep the image circular */
  border-radius: 5%; /* Make the image circular */
  background-color: rgba(255, 255, 255, 0.82); /* Background inside the hole */
  
  display: inline-block; /* Ensure alignment */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth hover effects */
}

/* Add hover effect to give a lift appearance */
.navbar-left img:hover {
  transform: scale(1.1); /* Slight zoom */
  box-shadow: inset 0 6px 8px rgba(0, 0, 0, 0.7), 0 6px 12px rgba(0, 0, 0, 0.3); /* Deeper shadow on hover */
}

/* Navbar search container */
.navbar-search {
  display: flex;
  align-items: center;
  flex: 3 1; /* Take up 50% of the navbar width */
  gap: 0.5rem;
  justify-content: flex-end;
  
}

.navbar-search input {
  border: 1px solid rgba(255, 255, 255, 0.4); /* Semi-transparent border */
  border-radius: 20px; /* Pill-shaped input */
  padding: 0.5rem 1rem;
  margin-left: 1rem; 
  margin-right: 1rem; 
  font-size: 1.5rem;
  color: #000000; /* White text */
  background: rgba(255, 255, 255, 0.2); /* Transparent input background */
  backdrop-filter: blur(5px); /* Frost effect */
  outline: none;
  transition: border-color 0.3s ease, transform 0.2s ease;
  width: 100%; /* Take up full available space */
}

.navbar-search input:focus {
  border-color: #3b82f6; /* Highlight border on focus */
  transform: scale(1.05); /* Slight enlarge on focus */
}

.navbar-search button {
  padding: 0.5rem 1rem;
  width: 10%;
  font-size: 2rem;
  color: #ffffff;
  background: rgba(59, 130, 246, 0.8); /* Semi-transparent blue */
  border: none;
  border-radius: 20px; /* Match input shape */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.navbar-search button:hover {
  background: rgba(37, 99, 235, 1); /* Darker blue on hover */
  transform: translateY(-2px); /* Lift effect */
}

.navbar-search button:active {
  transform: translateY(0); /* Remove lift on click */
}


/* Responsive design */
@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .navbar-left,
  .navbar-search {
    flex: 1 1;
    width: 100%; /* Full width for smaller screens */
    justify-content: center;
    margin-bottom: 0.5rem;
    margin-left: 1rem;
    margin-right: 1 rem;
  }

  .navbar-search input {
    flex-grow: 1;
  }
}
General styles for buttons on the left side

/* .navbar-left button {
  padding: 1rem 3rem;
  font-size: 1rem;
  color: #000000;
  background: rgba(162, 176, 198, 0.8); 
  border: none;
  border-radius: 80px;
  cursor: pointer;
  margin-left: 0.5rem; 
  transition: background-color 0.3s ease, transform 0.3s ease;
} */


.region-btn {
  height: 60px;
  padding: 1rem 2rem;
  padding: 0 2rem;
  border-radius: 6px !important; 
 
  background-color: rgb(159, 165, 200);
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 0.5 rem;

}


/* Hover and active effects */
.navbar-left button:hover {
  background: rgba(37, 99, 235, 1); /* Darker blue on hover */
  transform: translateY(-2px); /* Lift effect */
}

.navbar-left button:active {
  transform: translateY(0); /* Remove lift on click */
}

.welcome-message {
  font-family: 'Stylish', sans-serif;
  font-size: 25px;
  color: #f8e9ff;
  font-weight: bold;


}




.navbar-select {
  width: 150px;
  height: 60px;
  margin-left: 1rem;
  margin-right: 0.5rem;
  padding: 0 2rem; /* more space on sides for centering and arrow */
  border-radius: 6px;
  font-size: 1rem;
  text-align: center; /* horizontal text centering */
  line-height: 60px; /* vertical text centering */
  background-color: rgb(20, 119, 126);
  border: 1px solid #ccc;
  appearance: none;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem;
}
.navbar-select-well {
  width: 150px;
  height: 60px;
  margin-right: 0.5rem;
  padding: 0 2rem; /* more space on sides for centering and arrow */
  border-radius: 6px;
  font-size: 1rem;
  text-align: center; /* horizontal text centering */
  line-height: 60px; /* vertical text centering */
  background-color: rgb(84, 20, 126);
  border: 1px solid #ccc;
  appearance: none;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem;
}


.navbar-input {
  width: 80px;
  margin-right: 0.5rem;
  margin-top: 22px;
  margin-left: 0.5rem; 
}

.navbar-icon-btn {
  background: transparent;
  border: none;
  padding: 0.4rem;
  cursor: pointer;
}
.right-icon-btn {
  display: flex;
  flex-direction: row; /* Stack icon and text vertically */
  align-items: center;
  justify-content: center;
  padding: 16px 10px;
  font-size: 14px;
  color: white;
  background: linear-gradient(to right, #00b4db, #0083b0);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  gap: 4px; /* Space between icon and text */
  transition: all 0.3s ease;
}

.right-icon-btn2 {
  display: flex;
  flex-direction: row; /* Stack icon and text vertically */
  align-items: center;
  justify-content: center;
  padding: 18px 10px;
  font-size: 14px;
  color: white;
  background: linear-gradient(to right, #058833, #4bdc72);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  gap: 4px; /* Space between icon and text */
  transition: all 0.3s ease;
}


.right-icon-btn:hover {
  opacity: 0.9;
}



/* Navbar Icon Group */
.navbar-icons {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-right: 2rem;
}

/* Base Icon Button Style */
.icon-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  border: none;
  border-radius: 8px;
  background: linear-gradient(to right, #00b4db, #0083b0);
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

.icon-button:hover {
  transform: translateY(-2px);
  opacity: 0.95;
}

/* Individual Theme Colors */
.icon-button.home {
  background: linear-gradient(to right, #00b4db, #0083b0); /* Blue */
}

.icon-button.dashboard {
  background: linear-gradient(to right, #1d976c, #93f9b9); /* Green */
}

.icon-button.profile {
  background: linear-gradient(to right, #6a11cb, #2575fc); /* Purple */
}

.icon-button.logout {
  background: linear-gradient(to right, #cb2d3e, #ef473a); /* Red */
}

/* Avatar Icon Button (no padding to avoid distortion) */
.icon-button.profile .MuiIconButton-root {
  padding: 0;
  border-radius: 50%;
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/navbar.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf,kCAAkC;AAClC;EACE;;;;;GAKC,EAAE,wCAAwC;EAC3C,2BAA2B,EAAE,wCAAwC;EACrE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB,EAAE,yBAAyB;EAC9C,yCAAyC,EAAE,kBAAkB;EAC7D,cAAc,EAAE,4BAA4B;EAC5C,KAAK;EACL,OAAO;EACP,aAAa,EAAE,gCAAgC;;AAEjD;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;;EAEnB,SAAS,EAAE,0BAA0B;EACrC,SAAO,EAAE,oCAAoC;AAC/C;;AAEA,sDAAsD;AACtD;EACE,YAAY,EAAE,0BAA0B;EACxC,YAAY,EAAE,4BAA4B;EAC1C,iBAAiB,EAAE,4BAA4B;EAC/C,2CAA2C,EAAE,+BAA+B;;EAE5E,qBAAqB,EAAE,qBAAqB;EAC5C,qDAAqD,EAAE,yBAAyB;AAClF;;AAEA,+CAA+C;AAC/C;EACE,qBAAqB,EAAE,gBAAgB;EACvC,6EAA6E,EAAE,2BAA2B;AAC5G;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO,EAAE,oCAAoC;EAC7C,WAAW;EACX,yBAAyB;;AAE3B;;AAEA;EACE,0CAA0C,EAAE,4BAA4B;EACxE,mBAAmB,EAAE,sBAAsB;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc,EAAE,eAAe;EAC/B,oCAAoC,EAAE,iCAAiC;EACvE,0BAA0B,EAAE,iBAAiB;EAC7C,aAAa;EACb,uDAAuD;EACvD,WAAW,EAAE,iCAAiC;AAChD;;AAEA;EACE,qBAAqB,EAAE,8BAA8B;EACrD,sBAAsB,EAAE,4BAA4B;AACtD;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,cAAc;EACd,mCAAmC,EAAE,0BAA0B;EAC/D,YAAY;EACZ,mBAAmB,EAAE,sBAAsB;EAC3C,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,gCAAgC,EAAE,yBAAyB;EAC3D,2BAA2B,EAAE,gBAAgB;AAC/C;;AAEA;EACE,wBAAwB,EAAE,yBAAyB;AACrD;;;AAGA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,SAAO;IACP,WAAW,EAAE,mCAAmC;IAChD,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF;AACA;;;;;;;;;;;;;;;;EAgBE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6BAA6B;;EAE7B,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;;AAEpB;;;AAGA,6BAA6B;AAC7B;EACE,gCAAgC,EAAE,yBAAyB;EAC3D,2BAA2B,EAAE,gBAAgB;AAC/C;;AAEA;EACE,wBAAwB,EAAE,yBAAyB;AACrD;;AAIA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,iBAAiB;;;AAGnB;;;;;AAKA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe,EAAE,gDAAgD;EACjE,kBAAkB;EAClB,eAAe;EACf,kBAAkB,EAAE,8BAA8B;EAClD,iBAAiB,EAAE,4BAA4B;EAC/C,mCAAmC;EACnC,sBAAsB;EACtB,gBAAgB;;EAEhB,yDAAiO;EACjO,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe,EAAE,gDAAgD;EACjE,kBAAkB;EAClB,eAAe;EACf,kBAAkB,EAAE,8BAA8B;EAClD,iBAAiB,EAAE,4BAA4B;EAC/C,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;;EAEhB,yDAAiO;EACjO,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB,EAAE,mCAAmC;EACxD,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ,EAAE,gCAAgC;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,mCAAmC;EACxD,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ,EAAE,gCAAgC;EAC1C,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;;AAIA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,uDAAuD,EAAE,SAAS;AACpE;;AAEA;EACE,uDAAuD,EAAE,UAAU;AACrE;;AAEA;EACE,uDAAuD,EAAE,WAAW;AACtE;;AAEA;EACE,uDAAuD,EAAE,QAAQ;AACnE;;AAEA,wDAAwD;AACxD;EACE,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB","sourcesContent":["/* navbar.css */\n\n/* General styles for the navbar */\n.navbar {\n  background: rgba(\n    255,\n    255,\n    255,\n    0.2\n  ); /* Transparent white for glassy effect */\n  backdrop-filter: blur(10px); /* Apply blur for a frosted-glass look */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 2rem;\n  border-radius: 10px; /* Soft rounded corners */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  color: #ffffff; /* White text for contrast */\n  top:0;\n  left: 0;\n  height: 100px; /* Fixed height for the navbar */ \n  \n}\n\n/* Navbar menu container for images */\n.navbar-left {\n  display: flex;\n  align-items: center;\n  margin-left: 3rem;\n  margin-right: 1 rem;\n  \n  gap: 1rem; /* Spacing between items */\n  flex: 1; /* Take up 50% of the navbar width */\n}\n\n/* General styles for the images to appear in a hole */\n.navbar-left img {\n  height: 60px; /* Adjust size as needed */\n  width: 150px; /* Keep the image circular */\n  border-radius: 5%; /* Make the image circular */\n  background-color: rgba(255, 255, 255, 0.82); /* Background inside the hole */\n  \n  display: inline-block; /* Ensure alignment */\n  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth hover effects */\n}\n\n/* Add hover effect to give a lift appearance */\n.navbar-left img:hover {\n  transform: scale(1.1); /* Slight zoom */\n  box-shadow: inset 0 6px 8px rgba(0, 0, 0, 0.7), 0 6px 12px rgba(0, 0, 0, 0.3); /* Deeper shadow on hover */\n}\n\n/* Navbar search container */\n.navbar-search {\n  display: flex;\n  align-items: center;\n  flex: 3; /* Take up 50% of the navbar width */\n  gap: 0.5rem;\n  justify-content: flex-end;\n  \n}\n\n.navbar-search input {\n  border: 1px solid rgba(255, 255, 255, 0.4); /* Semi-transparent border */\n  border-radius: 20px; /* Pill-shaped input */\n  padding: 0.5rem 1rem;\n  margin-left: 1rem; \n  margin-right: 1rem; \n  font-size: 1.5rem;\n  color: #000000; /* White text */\n  background: rgba(255, 255, 255, 0.2); /* Transparent input background */\n  backdrop-filter: blur(5px); /* Frost effect */\n  outline: none;\n  transition: border-color 0.3s ease, transform 0.2s ease;\n  width: 100%; /* Take up full available space */\n}\n\n.navbar-search input:focus {\n  border-color: #3b82f6; /* Highlight border on focus */\n  transform: scale(1.05); /* Slight enlarge on focus */\n}\n\n.navbar-search button {\n  padding: 0.5rem 1rem;\n  width: 10%;\n  font-size: 2rem;\n  color: #ffffff;\n  background: rgba(59, 130, 246, 0.8); /* Semi-transparent blue */\n  border: none;\n  border-radius: 20px; /* Match input shape */\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.navbar-search button:hover {\n  background: rgba(37, 99, 235, 1); /* Darker blue on hover */\n  transform: translateY(-2px); /* Lift effect */\n}\n\n.navbar-search button:active {\n  transform: translateY(0); /* Remove lift on click */\n}\n\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .navbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .navbar-left,\n  .navbar-search {\n    flex: 1;\n    width: 100%; /* Full width for smaller screens */\n    justify-content: center;\n    margin-bottom: 0.5rem;\n    margin-left: 1rem;\n    margin-right: 1 rem;\n  }\n\n  .navbar-search input {\n    flex-grow: 1;\n  }\n}\nGeneral styles for buttons on the left side\n\n/* .navbar-left button {\n  padding: 1rem 3rem;\n  font-size: 1rem;\n  color: #000000;\n  background: rgba(162, 176, 198, 0.8); \n  border: none;\n  border-radius: 80px;\n  cursor: pointer;\n  margin-left: 0.5rem; \n  transition: background-color 0.3s ease, transform 0.3s ease;\n} */\n\n\n.region-btn {\n  height: 60px;\n  padding: 1rem 2rem;\n  padding: 0 2rem;\n  border-radius: 6px !important; \n \n  background-color: rgb(159, 165, 200);\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  font-size: 0.5 rem;\n\n}\n\n\n/* Hover and active effects */\n.navbar-left button:hover {\n  background: rgba(37, 99, 235, 1); /* Darker blue on hover */\n  transform: translateY(-2px); /* Lift effect */\n}\n\n.navbar-left button:active {\n  transform: translateY(0); /* Remove lift on click */\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Stylish&display=swap');\n\n.welcome-message {\n  font-family: 'Stylish', sans-serif;\n  font-size: 25px;\n  color: #f8e9ff;\n  font-weight: bold;\n\n\n}\n\n\n\n\n.navbar-select {\n  width: 150px;\n  height: 60px;\n  margin-left: 1rem;\n  margin-right: 0.5rem;\n  padding: 0 2rem; /* more space on sides for centering and arrow */\n  border-radius: 6px;\n  font-size: 1rem;\n  text-align: center; /* horizontal text centering */\n  line-height: 60px; /* vertical text centering */\n  background-color: rgb(20, 119, 126);\n  border: 1px solid #ccc;\n  appearance: none;\n\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='gray' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1.5 5l6 6 6-6H1.5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 1rem;\n}\n.navbar-select-well {\n  width: 150px;\n  height: 60px;\n  margin-right: 0.5rem;\n  padding: 0 2rem; /* more space on sides for centering and arrow */\n  border-radius: 6px;\n  font-size: 1rem;\n  text-align: center; /* horizontal text centering */\n  line-height: 60px; /* vertical text centering */\n  background-color: rgb(84, 20, 126);\n  border: 1px solid #ccc;\n  appearance: none;\n\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='gray' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1.5 5l6 6 6-6H1.5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 1rem;\n}\n\n\n.navbar-input {\n  width: 80px;\n  margin-right: 0.5rem;\n  margin-top: 22px;\n  margin-left: 0.5rem; \n}\n\n.navbar-icon-btn {\n  background: transparent;\n  border: none;\n  padding: 0.4rem;\n  cursor: pointer;\n}\n.right-icon-btn {\n  display: flex;\n  flex-direction: row; /* Stack icon and text vertically */\n  align-items: center;\n  justify-content: center;\n  padding: 16px 10px;\n  font-size: 14px;\n  color: white;\n  background: linear-gradient(to right, #00b4db, #0083b0);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  gap: 4px; /* Space between icon and text */\n  transition: all 0.3s ease;\n}\n\n.right-icon-btn2 {\n  display: flex;\n  flex-direction: row; /* Stack icon and text vertically */\n  align-items: center;\n  justify-content: center;\n  padding: 18px 10px;\n  font-size: 14px;\n  color: white;\n  background: linear-gradient(to right, #058833, #4bdc72);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  gap: 4px; /* Space between icon and text */\n  transition: all 0.3s ease;\n}\n\n\n.right-icon-btn:hover {\n  opacity: 0.9;\n}\n\n\n\n/* Navbar Icon Group */\n.navbar-icons {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  margin-right: 2rem;\n}\n\n/* Base Icon Button Style */\n.icon-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(to right, #00b4db, #0083b0);\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s ease;\n}\n\n.icon-button:hover {\n  transform: translateY(-2px);\n  opacity: 0.95;\n}\n\n/* Individual Theme Colors */\n.icon-button.home {\n  background: linear-gradient(to right, #00b4db, #0083b0); /* Blue */\n}\n\n.icon-button.dashboard {\n  background: linear-gradient(to right, #1d976c, #93f9b9); /* Green */\n}\n\n.icon-button.profile {\n  background: linear-gradient(to right, #6a11cb, #2575fc); /* Purple */\n}\n\n.icon-button.logout {\n  background: linear-gradient(to right, #cb2d3e, #ef473a); /* Red */\n}\n\n/* Avatar Icon Button (no padding to avoid distortion) */\n.icon-button.profile .MuiIconButton-root {\n  padding: 0;\n  border-radius: 50%;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
